<template>
  <div v-if="dados" class="bg-white rounded px-4 pb-4">
    <div class="row">
      <div class="col-md-12 mt-3">
        <div class="border px-2 pt-2 pb-1 rounded">
          <div class="label text-muted">{{ dados.tipoCadastro }}</div>
          <div class="text">{{ dados.nome }}</div>
        </div>
      </div>
      <div class="col-md-4 mt-3" v-if="dados.cadastroFinal">
        <div class="border px-2 pt-2 pb-1 rounded">
          <div class="label">Tipo</div>
          <div class="text">{{ dados.cadastroFinal.descTipoDependente }}</div>
        </div>
      </div>
      <div class="col-md-4 mt-3" v-if="dados.cadastroFinal">
        <div class="border px-2 pt-2 pb-1 rounded">
          <div class="label">Estado Civil</div>
          <div class="text">{{ dados.cadastroFinal.descEstadoCivil }}</div>
        </div>
      </div>
      <div class="col-md-4 mt-3" v-if="dados.cadastroFinal">
        <div class="border px-2 pt-2 pb-1 rounded">
          <div class="label">CPF</div>
          <div class="text">{{ dados.cadastroFinal.cpf }}</div>
        </div>
      </div>
      <div class="col-md-6 mt-3" v-if="dados.dataNascimento">
        <div class="border px-2 pt-2 pb-1 rounded">
          <div class="label">Data de Nascimento</div>
          <div class="text">{{ dados.dataNascimento }}</div>
        </div>
      </div>
      <div class="col-md-6 mt-3" v-if="dados.cadastroFinal">
        <div class="border px-2 pt-2 pb-1 rounded">
          <div class="label">Sexo</div>
          <div class="text">
            {{ dados.cadastroFinal.sexo === "m" ? "Masculino" : "Feminino" }}
          </div>
        </div>
      </div>
      <div class="col-md-12 mt-3" v-if="dados.cadastroFinal">
        <div class="border px-2 pt-2 pb-1 rounded">
          <div class="label">Nome da mãe</div>
          <div class="text">{{ dados.cadastroFinal.nomeMae }}</div>
        </div>
      </div>
    </div>
    <div class="row mt-4" v-if="dados.cadastroFinal">
      <div class="col-md-6 mt-3">
        <div class="border px-2 pt-2 pb-1 rounded">
          <div class="label">Telefone</div>
          <div class="text">{{ dados.cadastroFinal.telefone }}</div>
        </div>
      </div>
      <div class="col-md-6 mt-3">
        <div class="border px-2 pt-2 pb-1 rounded">
          <div class="label">E-mail</div>
          <div class="text">{{ dados.cadastroFinal.email }}</div>
        </div>
      </div>
    </div>
    <div class="row mt-4" v-if="dados.cadastroFinal">
      <div class="col-md-8 mt-3">
        <div class="border px-2 pt-2 pb-1 rounded">
          <div class="label">Endereço</div>
          <div class="text">
            {{ dados.cadastroFinal.rua }}, {{ dados.cadastroFinal.numero }}
          </div>
        </div>
      </div>
      <div class="col-md-4 mt-3">
        <template v-if="dados.cadastroFinal.complemento"
          ><div class="border px-2 pt-2 pb-1 rounded">
            <div class="label">Complemento</div>
            <div class="text">{{ dados.cadastroFinal.complemento }}</div>
          </div>
        </template>
      </div>
      <div class="col-md-4 mt-3">
        <div class="border px-2 pt-2 pb-1 rounded">
          <div class="label">Bairro</div>
          <div class="text">
            {{ dados.cadastroFinal.bairro }}
          </div>
        </div>
      </div>
      <div class="col-md-4 mt-3">
        <div class="border px-2 pt-2 pb-1 rounded">
          <div class="label">CEP</div>
          <div class="text">
            {{ dados.cadastroFinal.cep }}
          </div>
        </div>
      </div>
      <div class="col-md-4 mt-3">
        <div class="border px-2 pt-2 pb-1 rounded">
          <div class="label">Cidade / Estado</div>
          <div class="text">
            {{ dados.cadastroFinal.cidade }} / {{ dados.cadastroFinal.estado }}
          </div>
        </div>
      </div>
    </div>
    <div class="border rounded mt-4 p-3 bg-light">
      <div class="h5 mb-0">Plano de saúde</div>
      <div class="row">
        <div class="col-md-2 mt-3" v-if="dados.plano.codPlano">
          <div class="label">Código</div>
          <div class="text">
            {{ dados.plano.codPlano }}
          </div>
        </div>
        <div class="col mt-3" v-if="dados.plano.descricao">
          <div class="label">Descrição do Plano</div>
          <div class="text">
            {{ dados.plano.descricao }}
          </div>
        </div>
        <div class="col-md-3 mt-3" v-if="dados.plano.operadora">
          <div class="label">Operadora</div>
          <div class="text">
            {{ dados.plano.operadora }}
          </div>
        </div>
        <div class="col-md-3 mt-3" v-if="dados.plano.assistencia">
          <div class="label">Assistência</div>
          <div class="text">
            {{ dados.plano.assistencia }}
          </div>
        </div>
        <div class="col-md-2 mt-3" v-if="dados.plano.acomodacao">
          <div class="label">Acomodação</div>
          <div class="text">
            {{ dados.plano.acomodacao }}
          </div>
        </div>
        <div
          class="col-md-2 mt-3 text-left text-md-right"
          v-if="dados.plano.valorOpcionais"
        >
          <div class="label">Valor Opcionais</div>
          <div class="text">
            {{ dados.plano.valorOpcionais | currency }}
          </div>
        </div>
        <div class="col-md-2 mt-3 text-left text-md-right">
          <div class="label">Valor</div>
          <div class="text">
            {{ dados.plano.valor | currency }}
          </div>
        </div>
      </div>
      <template v-if="dados.descOpcionais">
        <div class="h6 mb-0 mt-4">Opcionais</div>
        <div class="row">
          <div
            class="col-12 mt-3"
            v-for="(opcional, index) in dados.descOpcionais"
            :key="index"
          >
            <div
              class="border px-2 pt-2 pb-1 rounded d-flex flex-column flex-md-row justify-content-between"
            >
              {{ opcional.opcional.label }}
              <div
                class="font-weight-bold mt-2 mt-md-0"
                v-if="opcional.opcional.value && !opcional.opcional.price"
              >
                {{ opcional.opcional.value | currency }}
              </div>
            </div>
          </div>
        </div>
      </template>
    </div>
    <div class="row" v-if="dados.totalPlano">
      <div class="col-md-12 mt-4 pr-5">
        <div class="label">VALOR TOTAL</div>
        <div class="text text-lg text-primary">
          {{ dados.totalPlano | currency }}
        </div>
      </div>
    </div>
    <div class="content" v-if="dados.totalEstornado">
      <div class="price-total mt-3">
        Total
        <strong class="text-primary">{{
          dados.totalEstornado | currency
        }}</strong>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "DadosVidaResumo",
  props: ["dados"],
  filters: {
    currency(valor) {
      var formatter = new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
      });
      return formatter.format(valor);
    },
  },
};
</script>
<style lang="scss" scoped>
.label {
  font-weight: 400;
  font-size: 0.9rem;
  margin-bottom: 5px;
  text-transform: uppercase;
}
.text {
  font-weight: bold;
  font-size: 1rem;
  text-transform: uppercase;
  color: #000;
  line-height: 1.4;
  &.text-lg {
    font-size: 1.4rem;
  }
}
</style>
